import { render, staticRenderFns } from "./AbaHeader.vue?vue&type=template&id=0224f6e1"
import script from "./AbaHeader.vue?vue&type=script&lang=js"
export * from "./AbaHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports